import { withRouter } from 'react-router'
import { Row, Col, Alert } from 'react-bootstrap'
import {
  ContentMailerContainer,
  RelatedContentContainer,
  FeedbackContainer,
  FavouritesToggle,
  CopyUrl
} from 'containers'
import Panel from 'components/Panel'
import InlineLoader from 'components/InlineLoader'
import InternalLink from 'components/InternalLink'
import HelpButton from 'components/HelpButton'

import { parseHtml } from 'helpers/utils'
import MetaData from '../MetaData'

const Faq = ({ faq, isFetching, id, device, takeOutInternalLinks, router }) => {
  const handleClick = (e) => {
    // Only intercept plain left clicks — ignore Ctrl/Cmd/Shift/Alt modified clicks
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
    if (e.button !== 0) return

    // IE11 compatible way to find closest anchor (no closest() support)
    let el = e.target
    while (el && el.tagName !== 'A') {
      el = el.parentElement
    }

    if (!el) return

    const href = el.getAttribute('href')
    if (!href) return

    // Ignore links meant to open in a new tab
    if (el.getAttribute('target') === '_blank') return

    if (href.startsWith('/')) {
      e.preventDefault()
      router.push(href)
    }
  }

  if (isFetching) {
    return <InlineLoader />
  }

  if (!faq.PK) {
    return (
      <Alert bsStyle="danger">
        The article was disabled or doesn't exist.{' '}
        <InternalLink to={'/'}>Home</InternalLink>
      </Alert>
    )
  }

  const panelButtons = (
    <div>
      <FeedbackContainer
        contentType="faqs"
        contentId={faq.PK}
        article={faq.name}
        panel
      />
      <CopyUrl />
      <ContentMailerContainer
        emailBody={takeOutInternalLinks(faq.val)}
        contentType="faqs"
        contentId={faq.PK}
      />
    </div>
  )

  const panelTitle = (
    <div>
      <span>{faq.name}</span>
      <FavouritesToggle
        contentType="faq"
        contentId={faq.PK}
        deviceId={faq.phonefk}
        contentTitle={faq.name}
      />
    </div>
  )

  return (
    <Row>
      <Col md={9}>
        <Panel title={panelTitle} buttons={panelButtons}>
          <div
            className="faq-content"
            onClick={handleClick}
            dangerouslySetInnerHTML={{ __html: parseHtml(faq.val) }}
          />
          <MetaData id={faq.salesforce_id} date={faq.update_date} />
          {faq.helper_module && <HelpButton moduleName={faq.helper_module} />}
        </Panel>
      </Col>

      <Col md={3}>
        <RelatedContentContainer
          contentId={id}
          contentType="faq"
          deviceId={device}
        />
      </Col>
    </Row>
  )
}

export default withRouter(Faq)
